import { useEffect, useMemo, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../firebase';

// Hook to subscribe to current user's availability declarations for a planning
// Returns a Map of eventId -> { available: boolean, seriesId?: string, updatedAt?: any }
export function useAvailabilities(planningId, userId) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!planningId || !userId) return;
    const ref = collection(db, 'plannings', planningId, 'availabilities');
    const q = query(ref, where('userId', '==', userId));
    const unsub = onSnapshot(q, (snap) => {
      const arr = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setItems(arr);
      setLoading(false);
    });
    return () => unsub();
  }, [planningId, userId]);

  const map = useMemo(() => {
    const m = new Map();
    for (const it of items) {
      if (it.eventId) m.set(it.eventId, it);
    }
    return m;
  }, [items]);

  return { map, list: items, loading };
}

